<template>
    <div id="header">
        <div class="container">
            <router-link class="link_logo" to="/">
                <div class="logo_box">
                    <TheLogo id="logo" />
                </div>
            </router-link>
            <div @click="toggleNavElements()" class="bars_header_nav" >
                <font-awesome-icon icon="fa-regular fa-bars" />
            </div>
            <span id="HideSensitive" class="hide_sensitive " @click="toggleSensitive"><font-awesome-icon :icon="['fas', 'eye']" class="eye_visible"/><font-awesome-icon :icon="['fas', 'eye-slash']" class="eye_slash"/></span>
            <div v-bind:class="{ 'has ' : accountStore.have_unread_notifications}" id="notifications">

                <button class="btn btn_icon dropdown-toggle" id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <font-awesome-icon v-if="accountStore.have_unread_notifications" icon="fa-regular fa-bell" class="fa-shake" />
                    <font-awesome-icon v-else icon="fa-regular fa-bell" />
                </button>
                    <div class="dropdown-menu" x-placement="bottom-start" aria-labelledby="dropdownMenu">
                        <ul v-if="accountStore.notifications.length">
                            <li v-for="(notification, key) in accountStore.notifications" :key="key" :class="{ 'unread' : notification.read == 0}"><router-link class="dropdown-item" :to="'/' + notification.path" @click="[ notification.read == 0 ? markReadNotification(notification.id, key) : '']">{{ notification.message }}<span>{{ globalStore.formatDate(notification.date) }}</span></router-link></li>
                        </ul>
                        <div v-else id="no_notifications" class="p-3">Nenhuma mensagem</div>
                    </div>
            </div>

            <div class="btn-group dropdown">
                <button class="btn btn_icon dropdown-toggle user_letter" id="dropdownLetterAccount" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span>{{ authStore.name.charAt(0) }}</span></button>
                <div class="dropdown-menu" id="dropdown_account" x-placement="bottom-start" aria-labelledby="dropdownLetterAccount" >
                    <p>
                        Olá, {{ first_name }}
                        <span>{{ authStore.email }}</span>
                    </p>
                    <router-link to="/account" class="dropdown-item d-flex justify-content-center flex-column">Minha conta</router-link>
                    <router-link to="/account/user" class=" dropdown-item d-flex justify-content-center flex-column">Dados de acesso</router-link>
                    <a @click="logOut" class="dropdown-item d-flex justify-content-center flex-column">Sair</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useAccountStore } from '@/stores/account';
import { useGlobalStore } from '@/stores/global';

const authStore = useAuthStore();
const accountStore = useAccountStore();
const globalStore = useGlobalStore();
const first_name = ref(null)
const emit = defineEmits(['isHidingSensitive']);

onBeforeMount(() =>{
    first_name.value = authStore.name.split(" ")[0];
    accountStore.tryAccountNotifications();
})

onMounted(() =>{
    const getSpan = document.getElementById('HideSensitive');
    const getSvg = document.querySelector('.eye_visible');
    const getSvgHiding = document.querySelector('.eye_slash');

    if(getSvg){
        if(accountStore.user_preferences.sensitive_information == 0){
            getSvg.style.display = 'block';
            getSvgHiding.style.display = 'none';
            getSpan.classList.remove('hiding')

            emit('isHidingSensitive', false)
        } else{
            getSvgHiding.style.display = 'block';
            getSvg.style.display = 'none'
            getSpan.classList.add('hiding')

            emit('isHidingSensitive', true)
        }
    }
})

async function logOut() {
    await authStore.tryLogout();
}

async function markReadNotification(id, key){
    await accountStore.tryMarkReadNotification(id, key)
}

function toggleSensitive(){
    globalStore.loader('show');
    const getSpan = document.getElementById('HideSensitive');
    const getSvg = document.querySelector('.eye_visible');
    const getSvgHiding = document.querySelector('.eye_slash');

    if(getSpan.classList.contains('hiding')){
        accountStore.trySwichSensitiveInfo(0).then(function(success){
            if(success){
                emit('isHidingSensitive', false)

                getSvg.style.display = 'block';
                getSvgHiding.style.display = 'none';
                getSpan.classList.remove('hiding')
                globalStore.loader('hide');
                accountStore.trySensitiveInfo();
            } else {
                globalStore.loader('hide');
                return;
            }
        })
    } else{
        accountStore.trySwichSensitiveInfo(1).then(function(success){
            if(success){
                emit('isHidingSensitive', true)

                getSvgHiding.style.display = 'block';
                getSvg.style.display = 'none'
                getSpan.classList.add('hiding')
                globalStore.loader('hide');
                accountStore.trySensitiveInfo();
            } else {
                globalStore.loader('hide');
                return;
            }
        })

    }
}

function toggleNavElements() {
    const getNavbarStyle = document.getElementById("navbar");
    const getNavFooter = document.getElementById("footer_nav");

    if (getNavbarStyle.style.height != "100%") {
        getNavbarStyle.style.height = "100%";
        if(getNavFooter){
            getNavFooter.style.display = "block";
        }

    } else {
        getNavbarStyle.style.height = "0px";
        if(getNavFooter){
            getNavFooter.style.display = "none";
        }
    }
}

</script>

<style scoped>
#header {
    border-bottom: 1px #ddd solid;
    position: fixed;
    z-index: 9999;
    background-color: #ffffff;
    width: 100%;
    padding-left: 255px;
}

#header .container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;
    padding-left: 25px;
}

.link_logo{
    position: fixed;
    left: 20px;
}

.link_logo svg{
    height: 30px
}

.bars_header_nav{
    position: fixed;
    left: 25px;
    cursor: pointer;
    top: 20px;
    display: none;
}

.bars_header_nav svg{
    width: 17px;
    height: 20px;
    fill: #767676;
}

.logo_box {
    margin-top: 0;
    margin-right: 0;
    width: 100%;
    outline: none;
    transition: 0.2s;
    position: relative;
}
#logo {
    width: 100px;
}

#logo_icon {
    position: absolute;
    top: 28px;
    left: 25px;
    width: 21px;
}

.btn_white_border {
    background-color: #fff;
    border: 1px #d7d7d7 solid;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 15px;
    border-radius: 25px;
    white-space: nowrap;
    width: 100%;
    border: 1px solid #d7d7d7;
    color: #595959;
}

.btn_white_border:hover {
    background-color: #e6e6e6;
}

.btn_icon {
    font-size: 16px;
    padding: 12px;
    border-radius: 25px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0 !important;
    font-size: 18px;
}

.btn_icon:hover {
    background-color: #ececec;
}

.btn_icon:active {
    background-color: #ececec;
}

.hide_sensitive {
    color: #28bc6d;
    cursor: pointer;
    user-select: none;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-right: 10px;
    display: flex;
}

.hide_sensitive:hover{
    background-color: #d7d7d7;
}

.hide_sensitive svg{
    margin: auto;
}

#notifications {
    position: relative;
    margin-left: 5px;
}

#notifications .dropdown-toggle::after {
    display: none;
}

.eye_slash{
    display: none;
}

#notifications.has:before {
    content: '';
    width: 13px;
    height: 13px;
    display: block;
    background-color: #ffb000;
    border-radius: 25px;
    position: absolute;
    top: 3px;
    right: 8px;
    border: 3px #f7f7f7 solid;
    z-index: 2;
}

#notifications ul {
    padding: 5px;
    margin: 0;
    max-height: 290px;
    overflow-y: scroll;
}

#notifications ul li {
    margin-bottom: 5px;
}

#notifications ul li:last-child {
    margin-bottom: 0px;
}

#notifications ul li span {
    display: block;
    font-size: 13px;
    color: #a1a1a1;
} 

#notifications .dropdown-menu {
    padding: 0;
    min-width: 250px;
}

#notifications .dropdown-menu .dropdown-item {
    white-space: inherit;
}

#notifications ul li.unread a {
    background-color: #e2ebf2;
    font-weight: 500;
}

#no_notifications {
    font-size: 14px;
    white-space: nowrap;
}

#dropdown_account {
    min-width: 200px;
}

#dropdown_account p {
    padding: 10px 15px 15px 15px;
    font-size: 14px;
    border-bottom: 1px #e4e4e4 solid;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 10px;
}

#dropdown_account p span {
    font-size: 12px;
    color: #9d9d9d;
    font-weight: 400;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}

#dropdownLetterAccount {
    padding-left: 6px;
    margin-left: 7px;
}

#dropdownLetterAccount span {
    background-color: #28bc6d;
    border-radius: 25px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
}

.logo_box {
    margin-top: 0;
    margin-right: 0;
    width: 100%;
    outline: none;
    transition: 0.2s;
}
#logo {
    width: 100px;
}

#toggle_menu {
    border: none;
    background-color: transparent;
    overflow: visible;
    width: 40px;
    height: 40px;
    padding: 10px;
    margin-top: -4px;
}

#toggle_menu svg {
    width: 17px;
    height: 23px;
    cursor: pointer;
    color: #767676 !important;
    vertical-align: bottom;
}

#toggle_menu svg:hover {
    color: #414951 !important;
}

#notification_svg:hover {
    fill: black;
}

@media screen and (min-width: 992px) {
    #notification_svg {
        display: none !important;
    }
}

@media screen and (max-width: 992px) {

    #logo_icon{
        display: none;
    }

    .logo_box{
        margin-top: -1px;
    }

    .logo_box svg{
        height: 30px;
    }

    .bars_header_nav{
        display: block;
    }

    .link_logo{

        left: 55px;
        display: inline-block;
    }

    .link_logo svg{
        height: 30px
    }

    #notification_svg {
        display: none;
        margin-top: -6px;
        margin-left: 10%;
    }
}
</style>